import React, { useEffect, useState } from "react";
import "../../../Activity/Create_Assessment_Activity/create_published/createPublishActivity.css";
import { MultiSelect } from "react-multi-select-component";

import ResponseLoding from "../../../Pre-read/Create_Assessment_PreRead/create_successfullPreRead/ResponseLoding";
import SuccessfullActivity from "../../Create_Assessment_Activity/create_successfull/SuccessfullActivity";
import {
  DatePickerComponent,
  DateTimePickerComponent,
} from "@syncfusion/ej2-react-calendars";
import axios from "../../../../axios";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Box,
  Button,
  TextField,
  MenuItem,
  Divider,
  Chip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { toast } from "react-toastify";

const CreatePublishActivity = ({
  change,
  createpublishActi,
  updateActivity,
  selectedLab,
  entryType,
  selectedGradeScale,
}) => {
  // debugger
  const [slistDropdown, setSlistDropdown] = useState([]);
  const [slistDropdown1, setSlistDropdown1] = useState([]);
  let dummyArr = [];
  const [preAssigned, setPreAssigned] = useState([]);
  const options = slistDropdown1;
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [checked, setChecked] = useState(false);
  const [checked1, setChecked1] = useState(false);
  const [lectureDate, setLectureDate] = useState();
  const [click, setClick] = useState(false);
  const [disable, setDisable] = useState(true);
  const [updatelivedropdowns, setUpdatelivedropdowns] = useState([]);
  let Teacher_id = localStorage.getItem("Teacher_id");
  let Teacher_Json = JSON.parse(Teacher_id);
  const [selected, setSelected] = useState([]);
  const dataArray = selected;
  const idArray = dataArray?.map((obj) => obj?.value);
  let schoolId = JSON.parse(localStorage.getItem("schoolId"));
  let academicYearId = JSON.parse(localStorage.getItem("academicYearId"));
  let timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );
  const academicSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );

  useEffect(() => {
    const helper = async () => {
      let response = await axios.get(
        `/api/v1/homework/studentActivity/getByAcivityId/${createpublishActi?.id}?status=draft&isOnlyList=true`,
      );
      // response.data.data.forEach((obj) => {
      //   let res = {
      //     label: obj.student_id.name,
      //     value: obj.student_id.id,
      //   };
      //   const exists = preAssigned.some((i) => i.value === res.value);
      //   if (!exists) {
      //     setPreAssigned([...preAssigned, res]);
      //   }
      // });
      let existingStudentsList = [];
      response &&
        response.data.data.map((student) =>
          existingStudentsList.push({
            value: student.student_id?.id,
            label: student.student_id?.name,
          }),
        );
      setSelected(existingStudentsList);
    };
    helper();
  }, [Teacher_Json]);
  // console.log(preAssigned);
  // useEffect(() => {
  //   setSelected(preAssigned);
  // }, [preAssigned]);

  console.log(selected);
  const handleChange12 = (selected) => {
    setSelected(selected);
  };
  // const [livedropdowns, setLivedropdowns] = useState([]);
  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  const handleChange1 = (event) => {
    setChecked1(event.target.checked);
  };
  let subjectId = createpublishActi?.subject_id?.id;
  let sectionId = createpublishActi?.section_id?.id;
  let standarId = createpublishActi?.standard_id?.id;

  useEffect(() => {
    const getActivtyStudentList = async () => {
      if (!timeTableSessionId) {
        return;
      }
      try {
        const studentList = await axios.get(
          `/api/v1/school/student/getList?standardId=${standarId}&sectionId=${sectionId}&timetableSession=${timeTableSessionId}`,
        );
        dummyArr = [];
        studentList.data.data.forEach((obj) => {
          let res = {
            value: `${obj.id}`,
            label: `${obj.name}`,
          };
          dummyArr.push(res);
        });
        setSlistDropdown1(dummyArr);
        studentList && setSlistDropdown(studentList.data.data);
      } catch (error) {}
    };
    getActivtyStudentList();
  }, [standarId]);

  const [activityUpdateState, setActivityUpdateState] = useState({
    updateDeadline: createpublishActi?.deadline,
    updateScheduleDate: "",
    updateScheduleTime: "",
    UpdateliveSession: null,
    UpdateliveSessionDate: null,
    notifyParents: "",
    notificationInst: "",
    updateStandared: "",
    updateSubject: "",
    updateSection: "",
    updateChapter: "",
  });
  const {
    updateDeadline,
    updateScheduleDate,
    updateScheduleTime,
    UpdateliveSession,
    UpdateliveSessionDate,
    notifyParents,
    notificationInst,
  } = activityUpdateState;
  const { description, updateTittle, updateTotalMarks, attach } =
    updateActivity;

  let updateCreateActi = {
    standard_id: createpublishActi?.standard_id?.id,
    subject_id: createpublishActi?.subject_id?.id,
    section_id: createpublishActi?.section_id?.id,
    book_id: createpublishActi?.book_id?.id,
    chapter_id: createpublishActi?.chapter_id?.id,
    academic_session_id: academicSessionId,
    timetable_session_id: timeTableSessionId,
    deadline: updateDeadline || createpublishActi?.deadline,
    schedule_date: updateScheduleDate || createpublishActi?.schedule_date,
    schedule_time: updateScheduleTime || createpublishActi?.schedule_time,
    teacher_id: Teacher_Json,
    name: updateTittle,
    description,
    status: "Published",
    attachments: attach,
    difficulty_level: createpublishActi?.difficulty_level?.id,
    total_marks: updateTotalMarks,
    notify_parents: notifyParents,
    notification_instruction: notificationInst,
    activity_type: "Lab",
    lab_ref_id: selectedLab?.id,
    entryType: entryType,
    gradeScaleId: entryType === "Grade" ? selectedGradeScale?._id : null,
    rubricScaleId: null,

    /* ADD THIS */
    correctAnswer: {
      explanation: updateActivity?.correctAnswer?.explanation || "",

      attachment: updateActivity?.correctAnswer?.attachment || [],

      attachments_sizeKb: [],
    },

    add_to_live_session: {
      lecture_id: UpdateliveSession,
      date: UpdateliveSessionDate,
    },
  };
  const updatelivesessionDropdown = async () => {
    if (!academicYearId || !timeTableSessionId) {
      toast.error(
        "These are no allocations set for your login. Please contact school admin for the assistance.",
      );
      return;
    }
    try {
      setUpdatelivedropdowns([]);
      const UpdateliveSession = await axios.get(
        `/api/v1/timetable/getLectureBySubject/academicYearId/${academicYearId}/schoolId/${schoolId}/standardId/${standarId}/sectionId/${sectionId}/timetableSessionId/${timeTableSessionId}/subjectId/${subjectId}/date/${lectureDate}`,
      );

      //UpdateliveSession.data.data.forEach((item) => {
      UpdateliveSession &&
        setUpdatelivedropdowns(UpdateliveSession?.data?.data[0].lectures);
      //});
    } catch (error) {}
  };
  useEffect(() => {
    updatelivesessionDropdown();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lectureDate]);

  useEffect(() => {
    if (activityUpdateState.updateDeadline !== "") {
      if (selected.length !== 0) {
        if (checked === true) {
          if (
            activityUpdateState.updateScheduleDate !== "" &&
            activityUpdateState.updateScheduleTime !== ""
          ) {
            setDisable(false);
          } else {
            setDisable(true);
          }
        } else {
          setDisable(false);
        }
        if (checked1 === true) {
          if (activityUpdateState.UpdateliveSession) {
            setDisable(false);
          } else {
            setDisable(true);
          }
        }
      }
    } else {
      setDisable(true);
    }
  }, [
    activityUpdateState.updateDeadline,
    checked,
    ,
    checked1,
    activityUpdateState.updateScheduleDate,
    activityUpdateState.updateScheduleTime,
  ]);
  const handelUpdatePublish = async (e) => {
    if (attach) {
      const formData = new FormData();
      formData.append("name", attach.name);
      formData.append("uploadActivityAttachment", attach);
      try {
        let res = await axios.post(
          `/api/v1/homework/activity/uploadAttachment/teacherId/${Teacher_Json}`,
          formData,
        );
        updateCreateActi.attachments = res.data.data;
      } catch (error) {
        console.log(error);
      }
    }
  };
  const helper = async () => {
    let res;
    try {
      res = await axios.post(
        `/api/v1/homework/activity/update/${createpublishActi.id}`,
        updateCreateActi,
      );
      console.log(res.data.data);
      res && setClick(true);
      setSuccess(true);
    } catch (error) {
      console.log(error);
    }
    try {
      let body = {
        teacher_id: Teacher_Json,
        student_id: idArray,
        //status: "published",
        status: "pending",
        deadline:
          activityUpdateState?.updateDeadline || createpublishActi?.deadline,
      };
      // let res1 = await axios.post(
      //   `/api/v1/homework/activity/${res?.data?.data?.id}/studentActivity/create`,
      //   body
      // );
      let res1 = await axios.post(
        `/api/v1/homework/activity/${res?.data?.data?.id}/studentActivity/addStudents`,
        body,
      );
      console.log(res1);
      if (res1.status === 201) {
        setLoading(false);
        setSuccess(true);
      } else {
        setSuccess(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const today = new Date();
  const minDateTime = new Date(today.getTime() + 30 * 60000);
  const disablePastDates = (date) => {
    return date < today;
  };

  function convertDateFormat(inputDate) {
    const [day, month, year] = inputDate.split("-");
    const dateObject = new Date(`${year}-${month}-${day}`);
    const convertedYear = dateObject.getFullYear();
    const convertedMonth = String(dateObject.getMonth() + 1).padStart(2, "0");
    const convertedDay = String(dateObject.getDate()).padStart(2, "0");
    const convertedDate = `${convertedYear}-${convertedMonth}-${convertedDay}`;
    return convertedDate;
  }
  function convertToISO(dateString) {
    const date = new Date(dateString);
    const isoDate = date.toISOString();
    return isoDate;
  }

  useEffect(() => {
    const hasDeadline = !!activityUpdateState.updateDeadline;
    const hasStudents = selected && selected.length > 0;

    const hasScheduleValid =
      !checked ||
      (checked &&
        activityUpdateState.updateScheduleDate &&
        activityUpdateState.updateScheduleTime);

    const hasLiveSessionValid =
      !checked1 || (checked1 && activityUpdateState.UpdateliveSession);

    if (hasDeadline && hasStudents && hasScheduleValid && hasLiveSessionValid) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [
    activityUpdateState.updateDeadline,
    selected,
    checked,
    checked1,
    activityUpdateState.updateScheduleDate,
    activityUpdateState.updateScheduleTime,
    activityUpdateState.UpdateliveSession,
  ]);

  function formatDate(inputDate) {
    const dateObject = new Date(inputDate);

    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }
  const deadline = activityUpdateState?.updateDeadline;
  if (deadline) {
    var minLiveSessionDate = new Date(deadline);
    minLiveSessionDate.setDate(minLiveSessionDate.getDate() - 7);
    var maxLiveSessionDate = new Date(deadline);
    maxLiveSessionDate.setDate(maxLiveSessionDate.getDate() + 28);
  }
  function convertTimeStringToAMPM(timeString) {
    if (timeString.length !== 4) {
      // Ensure the input string has the correct length
      console.error("Invalid time string format");
      return null;
    }

    const hours = timeString.substring(0, 2);
    const minutes = timeString.substring(2);

    const formattedTime = `${hours}:${minutes} ${hours < 12 ? "AM" : "PM"}`;
    return formattedTime;
  }
  return (
    <>
      {!click && (
        <Dialog
          open={true}
          onClose={(event, reason) => {
            if (reason !== "backdropClick") {
              change(false);
            }
          }}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle sx={{ fontWeight: 600 }}>
            Publish
            <IconButton
              onClick={() => change(false)}
              sx={{ position: "absolute", right: 10, top: 10 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent dividers>
            {/* Subject */}
            <TextField
              fullWidth
              margin="dense"
              label="Subject"
              value={createpublishActi?.subject_id?.name || ""}
              disabled
            />

            {/* Standard */}
            <TextField
              fullWidth
              margin="dense"
              label="Standard"
              value={createpublishActi?.standard_id?.name || ""}
              disabled
            />

            {/* Section */}
            <TextField
              fullWidth
              margin="dense"
              label="Section"
              value={createpublishActi?.section_id?.name || ""}
              disabled
            />

            {/* Deadline */}
            <Box mt={2}>
              <DateTimePickerComponent
                min={minDateTime}
                isDateDisabled={disablePastDates}
                placeholder="Deadline"
                value={createpublishActi?.deadline}
                onChange={(e) =>
                  setActivityUpdateState({
                    ...activityUpdateState,
                    updateDeadline: e.target.value,
                  })
                }
              />
            </Box>

            {/* Student MultiSelect */}
            <Box mt={3}>
              <MultiSelect
                options={options}
                value={selected}
                onChange={handleChange12}
                labelledBy="Select Students"
                className="custom-multiselect w-100"
              />
            </Box>

            {/* Add to Lecture */}
            <Box mt={3}>
              {deadline ? (
                <DatePickerComponent
                  placeholder="Add to Lecture Session"
                  width="100%"
                  min={minLiveSessionDate}
                  max={maxLiveSessionDate}
                  allowEdit={false}
                  onChange={(e) => {
                    if (!e.target.value) {
                      setLectureDate(null);
                    } else {
                      setChecked1(true);
                      setLectureDate(formatDate(e.target.value));
                    }
                  }}
                />
              ) : (
                <Typography variant="body2" color="error">
                  Select deadline first
                </Typography>
              )}
            </Box>

            {checked1 && (
              <Box mt={2}>
                <TextField
                  select
                  fullWidth
                  label="Select Lecture"
                  onChange={(e) =>
                    setActivityUpdateState({
                      ...activityUpdateState,
                      UpdateliveSession: e.target.value,
                      UpdateliveSessionDate: convertDateFormat(
                        e.target.options[e.target.selectedIndex].getAttribute(
                          "schdate",
                        ),
                      ),
                    })
                  }
                >
                  <MenuItem value="">Select Lecture</MenuItem>
                  {updatelivedropdowns?.map((lecture, index) => (
                    <MenuItem
                      key={index}
                      value={lecture.id}
                      schdate={lecture.date}
                    >
                      {lecture.name}, {lecture.date},{" "}
                      {convertTimeStringToAMPM(lecture.start_time)} -
                      {convertTimeStringToAMPM(lecture.end_time)}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
            )}

            {/* Publish Button */}
            <Box mt={4} textAlign="right">
              <Button
                variant="contained"
                onClick={() => {
                  helper();
                  setLoading(true);
                }}
                disabled={disable}
              >
                Publish
              </Button>
            </Box>
          </DialogContent>
        </Dialog>
      )}

      {success && <SuccessfullActivity />}
      {loading && <ResponseLoding />}
    </>
  );
};

export default CreatePublishActivity;
